import { render, staticRenderFns } from "./OutsourcingList.vue?vue&type=template&id=08998ed7&"
import script from "./OutsourcingList.vue?vue&type=script&lang=js&"
export * from "./OutsourcingList.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports